import { MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBInput, MDBRadio } from "mdb-react-ui-kit";
import Select from 'react-select';
import ImageUploader from "../ImageUploader/ImageUploader";

const Media = (props) => {
    const mediaTypeOptions = [
        { value: 'image', label: 'Image' },
        { value: 'video', label: 'Video' },
    ]
    const {formData, setFormData, webField, mobileField, inputErrors} = props;
    const label = props.label ?? 'Media';

    const onImageUploaded = async (id, upload_file) => {
        setFormData(prev => {
            return {
                ...prev,
                [id]: {
                    ...prev[id],
                    upload_file: upload_file
                }
            };
        });
    }
    const onImageDeleted = async (id) => {
        setFormData(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                upload_file: ''
            }
        }))
    }
    const handleMediaTypeChange = async (opt, target) => {
        setFormData(prev => ({
            ...prev,
            [target]: {
                ...prev[target],
                type: opt.value
            }
        }))
    }
    const handleMediaLinkTypeChange = async (e, target, link_type) => {
        setFormData(prev => ({
            ...prev,
            [target]: {
                ...prev[target],
                active_link: link_type
            }
        }))
    }
    const handleMediaExternalLinkChange = async (e, target) => {
        const value = e.target.value;
        setFormData(prev => ({
            ...prev,
            [target]: {
                ...prev[target],
                external_link: value
            }
        }))
    }


    return (
        <MDBCard className="cms-media mt-4">
            <MDBCardHeader>
                <MDBCardTitle>{ label }</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody className="d-flex align-items-center">
                <div className="flex-fluid">
                    <label className="d-flex align-items-center">
                        <span className="me-4">{label} (Web):</span>
                        <Select
                            options={mediaTypeOptions}
                            value={mediaTypeOptions.find(opt => opt.value === formData[webField]?.type)}
                            onChange={opt => handleMediaTypeChange(opt, webField)}
                        />
                    </label>
                    <div className="mt-2">
                        <div>
                            <MDBRadio
                                name={`${webField}_link_type`}
                                label='External Link'
                                checked={formData[webField]?.active_link == 'external'}
                                onChange={(e) => handleMediaLinkTypeChange(e, webField, 'external')}
                            />
                            <MDBInput
                                className={formData[webField]?.active_link == 'external' ? '' : 'disabled'}
                                value={formData[webField]?.external_link}
                                onChange={e => handleMediaExternalLinkChange(e, webField)}
                            />
                        </div>
                        <div className="mt-2">
                            <MDBRadio
                                name={`${webField}_link_type`}
                                label='Upload Media'
                                checked={formData[webField]?.active_link == 'upload'}
                                onChange={(e) => handleMediaLinkTypeChange(e, webField, 'upload')}
                            />
                            <ImageUploader
                                id={webField}
                                className={formData[webField]?.active_link == 'upload' ? '' : 'disabled'}
                                onImageUploaded={onImageUploaded}
                                onImageDeleted={onImageDeleted}
                                defaultSrc={formData[webField]?.upload_file}
                                folder="web"
                            />
                        </div>
                    </div>
                </div>

                <div className="ms-4 flex-fluid">
                    <label className="d-flex align-items-center">
                        <span className="me-2">{label} (Mobile):</span>
                        <Select
                            options={mediaTypeOptions}
                            value={mediaTypeOptions.find(opt => opt.value === formData[mobileField]?.type)}
                            onChange={opt => handleMediaTypeChange(opt, mobileField)}
                        />
                    </label>
                    <div className="mt-2">
                        <div>
                            <MDBRadio
                                name={`${mobileField}_link_type`}
                                label='External Link'
                                checked={formData[mobileField]?.active_link == 'external'}
                                onChange={(e) => handleMediaLinkTypeChange(e, mobileField, 'external')}
                            />
                            <MDBInput
                                className={formData[mobileField]?.active_link == 'external' ? '' : 'disabled'}
                                value={formData[mobileField]?.external_link}
                                onChange={e => handleMediaExternalLinkChange(e, mobileField)}
                            />
                        </div>
                        <div className="mt-2">
                            <MDBRadio
                                name={`${mobileField}_link_type`}
                                label='Upload Media'
                                checked={formData[mobileField]?.active_link == 'upload'}
                                onChange={e => handleMediaLinkTypeChange(e, mobileField, 'upload')}
                            />
                            <ImageUploader
                                id={mobileField}
                                className={formData[mobileField]?.active_link == 'upload' ? '' : 'disabled'}
                                onImageUploaded={onImageUploaded}
                                onImageDeleted={onImageDeleted}
                                defaultSrc={formData[mobileField]?.upload_file}
                                folder="mobile"
                            />
                        </div>
                    </div>
                </div>
            </MDBCardBody>
        </MDBCard>
    )
}

export default Media;